import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { userSelector } from 'slices/userSlice';
import ForgotPassword from 'views/ForgotPassword';
import AppoinmentDetails from "./views/appointmentDetails/appointmentDetails";

import OktaCallback from "views/OktaCallback";
import Login from "views/login";
import Register from "views/register";
import ResetPassword from 'views/ResetPassword';
import RequesterJoinRoom from 'views/appointment/RequesterJoinRoom/RequesterJoinRoom';
export const AuthRoutes = () => {
    const { pathname } = useLocation()
    const { isAuthenticated } = useSelector(userSelector);

    // Redirect to admin if already authenticated
    // if (isAuthenticated) {
    //     return <Navigate to="/admin" replace />;
    // }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/callback/okta" element={<OktaCallback />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Catch-all for unauthenticated users */}
             <Route path="/appointment-details" element={<AppoinmentDetails />} />
             <Route path="/appointment-details/view/requester/join-room-call" element={<RequesterJoinRoom />} />
            {pathname !== "/interview-invite" && <Route path={"*"} element={<Navigate to="/login" replace />} />}
        </Routes>
    )
}
